import { applyMiddleware, compose, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducer from '../reducers/index.ss';
import analytics from './analytics.ss';
import promiseMiddleware from './promiseMiddleware';

let middlewares = [promiseMiddleware, analytics];

middlewares = [composeWithDevTools(applyMiddleware(...middlewares))];

export default (initialState = {}) => {
  const store = createStore(reducer, initialState, compose(...middlewares));

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers/index.ss', () => {
      const nextReducer = require('../reducers/index.ss'); // eslint-disable-line global-require

      store.replaceReducer(nextReducer);
    });
  }
  return store;
};
